import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export default theme => ({
  header: {
    margin: '0 20px 0 20px'
  },
  stepperWrapper: {
    boxSizing: 'border-box',
    width: '100%',
    // padding: '0 5%',
    zIndex: 1
  },
  stepper: {
    width: 'auto',
    padding: '22px 20px 13px 20px',
    boxSizing: 'border-box',
    '@media (max-width: 1000px)': {
      width: '100%'
    }
  },
  step: _objectSpread({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: 'auto',
    overflow: 'auto',
    flex: 1
  }, theme.utils.scrollbar),
  stepHeader: {
    position: 'relative',
    width: '100%',
    padding: '20px',
    boxSizing: 'border-box',
    backgroundColor: theme.colors.actionMinor[50],
    borderRadius: '6px',
    '@media (max-width: 1024px)': {
      padding: 20
    }
  },
  stepHeaderContent: {
    display: 'flex',
    margin: 'auto',
    justifyContent: 'space-between'
    // '@media (max-width: 1024px)': {
    //     width: '100%',
    // },
  },
  headerContent: {
    width: '60%',
    '& span': {
      color: theme.colors.utility.textPrimary
    }
  },
  stepNumber: {
    marginRight: 20,
    '& span': {
      lineHeight: '20px'
    }
  },
  stepSubtitle: {
    marginTop: 1
  },
  matchFieldsAdvice: {
    marginTop: '12px',
    '& [class*="HoiPoi__HoiPoi__Advice__Text"]': {
      display: 'flex',
      alignItems: 'center',
      gap: '12px'
    }
  },
  stepContent: {
    maxWidth: '800px',
    height: 'auto',
    padding: '20px 0',
    boxSizing: 'border-box',
    '@media (max-width: 1024px)': {
      width: '100%',
      padding: 20
    }
  },
  stepFooter: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    gap: '20px',
    paddingRight: '20px',
    boxSizing: 'border-box'
  },
  stepFooterLeft: {
    display: 'flex',
    alignItems: 'center'
  },
  stepFooterRight: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '20px'
  },
  intercomHelp: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  intercomHelpButton: {
    fontWeight: 600
  },
  cancelButton: {
    '& span': {
      fontSize: '13px !important'
    }
  },
  backLink: {},
  error: {
    marginTop: 15,
    boxSizing: 'border-box',
    '@media (max-width: 1024px)': {
      width: '100%'
    }
  },
  radioContainer: {},
  modalCancelText: {
    marginBottom: 8
  },
  modalLoader: {
    marginTop: 30,
    textAlign: 'center',
    height: 50
  }
});